// MOD-07 (config-tier) form + başvuru tipleri.
//
// BE'nin ürettiği wire DTO'ları (generated) kullanılır; UI için garanti alanlı FE
// tiplerine map'lenir. Config-tier iki-durum publish (Draft↔Published) ve dil-satırı
// i18n (LanguagePicker filtresi; VariantPanel YOK). `fieldsJson` wire'da JSON string'tir
// → builder için `FormFieldModel[]`'e round-trip edilir (bkz. utils/fields).

import type { components } from '@/types/api';
import type { FieldType, FormTypeValue, SubmissionStatus } from './constants';

export type { FieldType, FormTypeValue, SubmissionStatus } from './constants';

/** Wire DTO'ları (generated). */
export type FormDtoWire = components['schemas']['FormDto'];
export type FormListItemDtoWire = components['schemas']['FormListItemDto'];
export type CreateFormRequest = components['schemas']['CreateFormRequest'];
export type UpdateFormRequest = components['schemas']['UpdateFormRequest'];
export type FormSubmissionDtoWire = components['schemas']['FormSubmissionDto'];
export type FormSubmissionListItemDtoWire = components['schemas']['FormSubmissionListItemDto'];
export type PublicFormFieldDtoWire = components['schemas']['PublicFormFieldDto'];

/** Config-tier iki-durum yayın durumu. */
export type ConfigStatus = 'Draft' | 'Published';

export function normalizeConfigStatus(status: string | null | undefined): ConfigStatus {
  return status === 'Published' ? 'Published' : 'Draft';
}

export function normalizeFormType(value: string | null | undefined): FormTypeValue {
  return value === 'Quote' || value === 'Career' ? value : 'Contact';
}

export function normalizeSubmissionStatus(value: string | null | undefined): SubmissionStatus {
  return value === 'Read' || value === 'Processed' || value === 'Quarantined' ? value : 'New';
}

/**
 * Builder'ın çalıştığı alan modeli. `id` yalnız client tarafı (dnd + seçim için
 * kararlı anahtar) — FieldsJson'a serialize EDİLMEZ; `order` ise dizideki konumdan
 * türetilir (bkz. serializeFields).
 */
export interface FormFieldModel {
  id: string;
  key: string;
  type: FieldType;
  label: string;
  required: boolean;
  options: string[];
  maxLength: number | null;
}

// --- Liste ---

export interface FormListItem {
  id: string;
  title: string;
  slug: string;
  formType: FormTypeValue;
  languageId: string;
  groupId: string;
  status: ConfigStatus;
  submissionCount: number;
  updatedAt: string;
}

// --- Detay ---

export interface FormDetail {
  id: string;
  title: string;
  slug: string;
  formType: FormTypeValue;
  fields: FormFieldModel[];
  emailRecipients: string[];
  kvkkText: string;
  captchaEnabled: boolean;
  languageId: string;
  groupId: string;
  status: ConfigStatus;
  variantLanguageCodes: string[];
}

// --- Input ---

/** Liste ekranından "Yeni Form" — kabuk oluşturur; alanlar builder'da doldurulur. */
export interface FormCreateInput {
  title: string;
  formType: FormTypeValue;
  slug?: string | null;
  languageId?: string | null;
}

/** Builder'ın "Kaydet" akışı — tam güncelleme (fieldsJson serialize edilir). */
export interface FormUpdateInput {
  title: string;
  formType: FormTypeValue;
  slug: string;
  fields: FormFieldModel[];
  emailRecipients: string[];
  kvkkText: string;
  captchaEnabled: boolean;
}

// --- Başvuru (submission) ---

export interface FormSubmissionListItem {
  id: string;
  formId: string;
  status: SubmissionStatus;
  hasAttachment: boolean;
  submittedAt: string;
}

export interface FormSubmissionDetail {
  id: string;
  formId: string;
  data: Record<string, unknown>;
  fileIds: string[];
  submitterIp: string | null;
  kvkkConsentAt: string | null;
  status: SubmissionStatus;
  submittedAt: string;
}

export interface FormListQuery {
  formType?: FormTypeValue;
  languageId?: string;
  page?: number;
  pageSize?: number;
}

export interface SubmissionListQuery {
  status?: SubmissionStatus;
  from?: string;
  to?: string;
  page?: number;
  pageSize?: number;
}
